import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#48B7A7",
    },
    secondary: {
      main: "#3cc375",
    },
    background: {
      paper: "#E8F9FD",
    },
  },
});
